import { IntegrationTypeEnum } from "@finway-group/shared/lib/models"
import React from "react"
import { CsPurchaseRequestFeatureFlag } from "~Features/settings/integrations/CsPurchaseRequestFeatureFlag"
import SettingsLayout from "~Features/settings/settings.layout"
import { useIntegrationConfigurations } from "~Shared/queries/integration.queries"
import { CsPersonioFeatureFlag } from "./personio/CsPersonioFeatureFlag"
import PersonioIntegration from "./personio/personioIntegration"

const SystemIntegrationsContainer = () => {
    const { data, refetch } = useIntegrationConfigurations()
    return (
        <SettingsLayout titleKey="label:integrations">
            <div className="flex flex-col w-full justify-items-center">
                <PersonioIntegration connection={data?.[IntegrationTypeEnum.PERSONIO]} refetch={refetch} />
                <CsPersonioFeatureFlag />
                <CsPurchaseRequestFeatureFlag />
            </div>
        </SettingsLayout>
    )
}

export default React.memo(SystemIntegrationsContainer)
